import { render } from "./LogoComponent.vue?vue&type=template&id=7e2aa0a5&ts=true"
import script from "./LogoComponent.vue?vue&type=script&lang=ts"
export * from "./LogoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__